import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';

function Video() {
    const [video, setVideo] = useState(null);
    const [loading, setLoading] = useState(true);
    const { nom, episodeIndex, seasonIndex } = useParams();


    useEffect(() => {
        const fetchData = async () => {
            try {
                let url = `/media/video/${nom}`;
    
                // Si episodeIndex existe, c'est une série et on ajoute l'ID de l'épisode à l'URL
                if (episodeIndex) {
                    url += `/${seasonIndex}/${episodeIndex}`;
                }

    
                const response = await fetch(url);
                const data = await response.json();
    
                console.log("Video data from server:", data);
    
                setVideo(data);
                setLoading(false);
            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        };
    
        fetchData();
    }, [nom, episodeIndex, seasonIndex]); // Assurez-vous de passer seasonIndex dans les dépendances

console.log(video);

    return (
        <section className="container_news log">
            {loading ? (
                <p>Loading...</p>
            ) : (
                video ? (
                    <video className="video_player" controls autoPlay id="vid">
                        {video.type === 'serie' && episodeIndex ? (
                            <source src={video.episode} type="video/mp4" />
                        ) : (
                            <source src={video.media.bd} type="video/mp4" />
                        )}
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <p>No video data available.</p>
                )
            )}
            <a href="/acceuil" className="btn-lecture">Retour à la liste</a>
        </section>
    );
}

export default Video;
